export default __webpack_public_path__ + "static/media/image-cushion-r-w@2x.4ffd5b5a.png";